import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import UmaBarathi from './../../../../assets/images/Doctorsimages/UMABARATHIDR.png' // Updated image import
import favicon from "./../../../../assets/images/favicon.ico"
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';


const UmaBarathiDoc = () => { // Renamed component
  const navigate = useNavigate(); 
   useEffect(() => {
       document.title = "Dr. Uma Barathi S A | Best Homeopathy & Aesthetic Doctor in Chennai |Hair, Skin & Wellness Consultant"; // Updated title
       const metaDescription = document.querySelector("meta[name='description']");
       if (metaDescription) {
         metaDescription.setAttribute(
           "content",
           "Consult Dr. Uma Barathi S A (BHMS, PGDCC, DT), Consultant Homeopathy and Aesthetic Doctor in Chennai. Expert in skin, hair ,gfc treatments with a holistic approach to beauty and health." // Updated meta description
         );
       }
       const metaKeywords = document.querySelector("meta[name='keywords']");
     if (metaKeywords) {
  metaKeywords.setAttribute(
    "content",
    "aesthetic doctor in Chennai, homeopathy doctor in Chennai, Hair prp treatment in Chennai, Hair Gfc treatment in Chennai, Best Doctor for skin treatment, female homeopathy doctor in Chennai, best aesthetic homeopathy doctor near me, skin and hair specialist in Chennai, trichology expert in Chennai, cosmetology doctor in Chennai, holistic skin treatment in Chennai, acne and pigmentation homeopathy doctor Chennai, natural beauty and wellness doctor in Tamil Nadu, homeopathy doctor for hair fall and skin care Chennai" // Updated SEO keywords
  );
}

        // Set canonical link
        const existingCanonical = document.querySelector("link[rel='canonical']");
        if (existingCanonical) {
          existingCanonical.setAttribute("href", "https://www.h-cura.com/doctors/dr-uma-barathi-homeopathy-aesthetic-chennai"); // Updated canonical link
        } else {
          const canonicalLink = document.createElement("link");
          canonicalLink.setAttribute("rel", "canonical");
          canonicalLink.setAttribute("href", "https://www.h-cura.com/doctors/dr-uma-barathi-homeopathy-aesthetic-chennai"); // Updated canonical link
          document.head.appendChild(canonicalLink);
        }
        // Set favicon
     const existingFavicon = document.querySelector("link[rel='icon']");
     if (existingFavicon) {
       existingFavicon.setAttribute("href", favicon);
     } else {
       const faviconLink = document.createElement("link");
       faviconLink.setAttribute("rel", "icon");
       faviconLink.setAttribute("type", "image/x-icon");
       faviconLink.setAttribute("href", favicon);
       document.head.appendChild(faviconLink);
     }
     }, []);

const handleDownloadPdf = () => {
  const container = document.querySelector('.veenadoc'); // Keeping veenadoc classname

  // Add PDF-specific class to container
  container.classList.add('veenadoc-pdf-mode'); // Keeping veenadoc classname

  // Store original styles
  const originalStyles = new Map();

  // Temporarily modify styles for PDF capture
  const allElements = container.querySelectorAll('*');
  allElements.forEach(el => {
    originalStyles.set(el, {
      transition: el.style.transition,
      animation: el.style.animation,
      transform: el.style.transform,
      filter: el.style.filter
    });

    el.style.transition = 'none';
    el.style.animation = 'none';
    el.style.transform = 'none';
    el.style.filter = 'none';
  });

  // Fix hero section height for PDF
  const heroSection = container.querySelector('.veenadoc-hero-section'); // Keeping veenadoc classname
  if (heroSection) {
    heroSection.style.minHeight = 'auto';
    heroSection.style.padding = '40px 0';
  }

  // Ensure images are fully loaded and visible
  const images = container.querySelectorAll('img');
  images.forEach(img => {
    img.style.opacity = '1';
  });

  // Wait a moment for styles to apply
  setTimeout(() => {
    html2canvas(container, {
      scale: 2,
      dpi: 300,
      useCORS: true,
      allowTaint: true,
      letterRendering: true,
      backgroundColor: '#ffffff',
      logging: false,
      windowWidth: container.scrollWidth,
      windowHeight: container.scrollHeight,
      scrollY: -window.scrollY,
      scrollX: -window.scrollX,
      imageTimeout: 0,
      removeContainer: false
    }).then(canvas => {
      // Remove PDF-specific class
      container.classList.remove('veenadoc-pdf-mode'); // Keeping veenadoc classname

      // Restore original styles
      allElements.forEach(el => {
        const original = originalStyles.get(el);
        el.style.transition = original.transition;
        el.style.animation = original.animation;
        el.style.transform = original.transform;
        el.style.filter = original.filter;
      });

      // Restore hero section
      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      const imgData = canvas.toDataURL('image/jpeg', 0.95);
      const pdf = new jsPDF('p', 'mm', 'a4', true);

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;

      // Define margins for the PDF
      const marginLeft = 10; // 10mm gap on the left
      const marginRight = 10; // 10mm gap on the right to maintain symmetry and prevent cutting
      const availableWidth = pdfWidth - marginLeft - marginRight;

      // Calculate scaling factor to fit the canvas content within the available width
      const scaleFactor = availableWidth / canvasWidth;

      // Apply the scale factor to both width and height to maintain aspect ratio
      const imgWidth = canvasWidth * scaleFactor;
      const imgHeight = canvasHeight * scaleFactor;

      // Calculate the number of pages needed for vertical content overflow
      const pages = Math.ceil(imgHeight / pdfHeight);

      for (let i = 0; i < pages; i++) {
        if (i > 0) {
          pdf.addPage();
        }
        // Add image to PDF, using marginLeft for the x coordinate
        pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
      }

      pdf.save('Dr.Uma_Barathi_S_A_Profile.pdf'); // Updated PDF filename
    }).catch(error => {
      console.error('Error generating PDF:', error);
      alert('Failed to generate PDF. Please try again.');

      // Remove PDF-specific class
      container.classList.remove('veenadoc-pdf-mode'); // Keeping veenadoc classname

      // Restore hero section
      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      allElements.forEach(el => {
        const original = originalStyles.get(el);
        if (original) {
          el.style.transition = original.transition;
          el.style.animation = original.animation;
          el.style.transform = original.transform;
          el.style.filter = original.filter;
        }
      });
    });
  }, 100);
};

  return (
    <>
      <div className="veenadoc"> {/* Keeping veenadoc classname */}
        {/* Hero Section */}
        <div className="veenadoc-hero-section"> {/* Keeping veenadoc classname */}
          <div className="veenadoc-hero-background"> {/* Keeping veenadoc classname */}
            <div className="veenadoc-wave-pattern"> {/* Keeping veenadoc classname */}
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none"> {/* Keeping veenadoc classname */}
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes"> {/* Keeping veenadoc classname */}
              <div className="veenadoc-shape veenadoc-shape-1"></div> {/* Keeping veenadoc classname */}
              <div className="veenadoc-shape veenadoc-shape-2"></div> {/* Keeping veenadoc classname */}
              <div className="veenadoc-shape veenadoc-shape-3"></div> {/* Keeping veenadoc classname */}
              <div className="veenadoc-shape veenadoc-shape-4"></div> {/* Keeping veenadoc classname */}
            </div>
          </div>

          <div className="veenadoc-container"> {/* Keeping veenadoc classname */}
            <div className="veenadoc-hero-content"> {/* Keeping veenadoc classname */}
              <div className="veenadoc-hero-left"> {/* Keeping veenadoc classname */}
                <h1 className="veenadoc-hero-title"> {/* Keeping veenadoc classname */}
                  <span className="veenadoc-title-highlight">Dr. Uma Barathi S A</span> {/* Keeping veenadoc classname, Updated Name */}
                  <span className="veenadoc-title-credentials">(BHMS, PGDCC, DT)</span> {/* Keeping veenadoc classname, Updated Credentials */}
                  <span className="veenadoc-title-location">Chennai</span> {/* Keeping veenadoc classname, Updated Location */}
                </h1>

                <div className="veenadoc-hero-description"> {/* Keeping veenadoc classname */}
                  <p>
                    Dr. Uma Barathi S A (B.H.M.S, P.G.D.C.C, D.T) is a dedicated Consultant Homeopathy &amp; Aesthetic Doctor now practising at H-Cura Multispeciality Clinic, Chennai. With her dual expertise in classical homeopathy and advanced aesthetic therapies, she brings a holistic, science-based, and patient-centred approach to skin, hair, and overall wellness care.
                  </p>
                  <p>
                    Having completed her education and postgraduate credentials, Dr. Uma Barathi provides natural, effective, and modern treatments under one roof. At H-Cura, her mission is to combine the nurturing philosophy of homeopathy with results-oriented aesthetic procedures — offering patients care that is safe, gentle, and transformative.
                  </p>
                </div>

                <div className="veenadoc-hero-actions"> {/* Keeping veenadoc classname */}
                  <button
              className="veenadoc-btn-primary-gradient"
              onClick={() => navigate('/bookconsultation')}
            >
              <span className="veenadoc-btn-icon">📞</span> {/* Keeping veenadoc classname */}
              <span>Book Consultation</span>
              <div className="veenadoc-btn-shine"></div> {/* Keeping veenadoc classname */}
            </button>
                </div>
              </div>

              <div className="veenadoc-hero-right"> {/* Keeping veenadoc classname */}
                <div className="veenadoc-doctor-showcase"> {/* Keeping veenadoc classname */}
                  <div className="veenadoc-doctor-frame"> {/* Keeping veenadoc classname */}
                    <div className="veenadoc-frame-glow"></div> {/* Keeping veenadoc classname */}
                    <div className="veenadoc-image-container"> {/* Keeping veenadoc classname */}
                      <img src={UmaBarathi} alt="Dr. Uma Barathi S A – Consultant Homeopathy & Aesthetic Doctor in Chennai" className="veenadoc-doctor-image" title='Dr. Uma Barathi S A | Best Homeopathy & Aesthetic Doctor for Skin and Hair in Chennai' /> {/* Keeping veenadoc classname, Updated image src, alt, title */}
                      <div className="veenadoc-image-overlay"></div> {/* Keeping veenadoc classname */}
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section"> {/* Keeping veenadoc classname */}
          <div className="veenadoc-container"> {/* Keeping veenadoc classname */}
            <div className="veenadoc-article-layout"> {/* Keeping veenadoc classname */}

              {/* Main Article Content */}
              <div className="veenadoc-article-main"> {/* Keeping veenadoc classname */}

                {/* Introduction */}
                <div className="veenadoc-article-block"> {/* Keeping veenadoc classname */}
                  <h2>Professional Qualifications &amp; Educational Background</h2> {/* Updated Heading */}
                  <p>
                    Dr. Uma Barathi holds a BHMS (Bachelor of Homeopathic Medicine &amp; Surgery) degree from Sivaraj Homeopathic Medical College &amp; Research Institute, affiliated with The Tamil Nadu Dr. M.G.R. Medical University. In order to expand her scope into aesthetic medicine and hair-care science, she pursued advanced training: a Post Graduate Diploma in Clinical Cosmetology (PGDCC) and a Diploma in Trichology (D.T.). Her credentials enable her to practice more than conventional homeopathy — she brings clinical cosmetology and trichology under the umbrella of a holistic healing model.
                  </p>
                  <p>
                    With approximately two years of clinical experience, Dr. Uma Barathi has worked both in hospital settings and in private practice before joining H-Cura. Her early practical exposure includes one year at Ram Medical Centre in Ariyalur and a year running her own clinic in Villupuram. Now at H-Cura, she continues to extend her reach and deliver advanced aesthetic &amp; homeopathy treatments to a broader patient population.
                  </p>
                </div>

                {/* Clinical Journey & Professional Contributions */}
                <div className="veenadoc-article-block"> {/* Keeping veenadoc classname */}
                  <h2>Role at H-Cura &amp; Practice Philosophy</h2> {/* Updated Heading */}
                  <p>
                      In her current role as Consultant Homeopathy &amp; Aesthetic Doctor at H-Cura Multispeciality Clinic, Dr. Uma Barathi combines:
                  </p>
                  <ul>
                      <li className="veenadoc-search-queries-list">Classical homeopathic diagnosis &amp; remedy-based treatments for systemic balance</li>
                      <li className="veenadoc-search-queries-list">Clinical Cosmetology methods for skin rejuvenation, pigmentation correction, anti-aging care</li>
                      <li className="veenadoc-search-queries-list">Trichology-oriented therapies for hair growth, scalp rehabilitation, and hair quality enhancement</li>
                  </ul>
                  <p>
                      Her treatment philosophy is succinctly captured in her quote:
                      &quot;Enhancing beauty and wellness through gentle, holistic care.&quot;
                  </p>
                  <p>
                      She believes that health and appearance are deeply connected. Thus, her treatment plans always address the root cause of any issue—be it skin discoloration, persistent acne, hair thinning, or signs of premature aging—while also providing aesthetic therapies that deliver visible improvements.
                  </p>
                  <p>
                      Patients at H-Cura benefit from her empathetic communication style, evidence-based approach, and personalized care planning. She emphasizes regular follow-ups, monitoring improvements in both internal wellness (digestion, immunity, hormonal balance) and external outcomes (skin clarity, hair thickness, youthful appearance).
                  </p>
                </div>

               
                     <div className="veenadoc-sidebar-card"> {/* Keeping veenadoc classname */}
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid"> {/* Keeping veenadoc classname */}
                    <div className="veenadoc-info-item"> {/* Keeping veenadoc classname */}
                      <span className="veenadoc-info-label">Qualification:</span> {/* Keeping veenadoc classname */}
                      <span className="veenadoc-info-value">BHMS, PGDCC, DT</span> {/* Keeping veenadoc classname, Updated Value */}
                    </div>
                    <div className="veenadoc-info-item"> {/* Keeping veenadoc classname */}
                      <span className="veenadoc-info-label">Experience:</span> {/* Keeping veenadoc classname */}
                      <span className="veenadoc-info-value">2 Years</span> {/* Keeping veenadoc classname, Updated Value */}
                    </div>
                    <div className="veenadoc-info-item"> {/* Keeping veenadoc classname */}
                      <span className="veenadoc-info-label">Specialization:</span> {/* Keeping veenadoc classname */}
                      <span className="veenadoc-info-value">Homeopathy &amp; Aesthetics, Trichology</span> {/* Keeping veenadoc classname, Updated Value */}
                    </div>
                    <div className="veenadoc-info-item"> {/* Keeping veenadoc classname */}
                      <span className="veenadoc-info-label">Locations:</span> {/* Keeping veenadoc classname */}
                      <span className="veenadoc-info-value">Chennai</span> {/* Keeping veenadoc classname, Updated Value */}
                    </div>
                  </div>
                </div>
                {/* Expertise in Chronic Conditions */}
                <div className="veenadoc-article-block"> {/* Keeping veenadoc classname */}
                  <h2>Areas of Expertise at H-Cura</h2> {/* Updated Heading */}
                  <p>Below is an overview of her core areas of specialization:</p>
                  <h3>Homeopathy (Internal &amp; Chronic Care)</h3>
                  <p className="veenadoc-search-queries-list">Allergies, hormonal imbalance, digestive issues, skin disorders (eczema, psoriasis, recurrent acne), joint pain, stress-related complaints, menopausal symptoms, general fatigue</p>
                  <h3>Skin &amp; Aesthetic Treatments</h3>
                  <p className="veenadoc-search-queries-list">Advanced acne management, pigmentation &amp; dark spots, melasma correction, anti-aging peels, chemical peels, micro-needling support (in coordination with clinic protocols), skin rejuvenation packages, facial glow therapies</p>
                  <h3>Hair &amp; Trichology</h3>
                  <p className="veenadoc-search-queries-list">Hair fall reduction, androgenetic alopecia support, dandruff &amp; seborrheic scalp treatment, Growth Factor Concentrate (GFC) therapy, QR678 hair growth therapy, Platelet Rich Plasma (PRP) support (as offered by H-Cura), Low-Level Laser Therapy (LLLT) support and guidance, hair growth serums, scalp boosters, and nutritional &amp; homeopathic adjuncts for healthy hair regrowth.</p>
                  <h3>Wellness &amp; Preventive Care</h3>
                  <p className="veenadoc-search-queries-list">Lifestyle counselling, nutrition-supportive homeopathic supplements, detox support, stress and sleep management, skin-hair wellness packages combining internal remedies + topical care</p>
                  <p>Each of these categories is fully integrated within H-Cura’s infrastructure, ensuring synergy between homeopathy, dermatology, cosmetology, and wellness consultation.</p>
                </div>

                {/* Leading Aesthetic Doctor in Bangalore */}
                <div className="veenadoc-article-block"> {/* Keeping veenadoc classname */}
                  <h2>Advanced Skin Treatments Offered</h2> {/* Updated Heading */}
                  <p>At H-Cura Multispeciality Clinic, under Dr. Uma Barathi’s aesthetic-homeopathy integration, the skin-care treatments she oversees or collaborates with include:</p>
                  <h3>Customized Acne Protocols</h3>
                  <ul className="veenadoc-search-queries-list">
                      <li>Homeopathic remedies for acne predisposition, hormonal acne, post-inflammatory pigmentation</li>
                      <li>Adjunctive topical aesthetic peels or dermacare peels (managed by clinic protocols)</li>
                      <li>Follow-up homeopathic care to minimize scar formation and support skin healing</li>
                  </ul >
                  <h3>Pigmentation &amp; Melasma Correction</h3>
                  <ul className="veenadoc-search-queries-list">
                      <li>Combination of homeopathic internal management (hormonal balance, liver detox, immunity support)</li>
                      <li>External aesthetic protocols such as chemical peels, pigment-reduction treatments (as per H-Cura’s cosmetology arm)</li>
                      <li>Maintenance plans to prevent re-darkening</li>
                  </ul>
                  <h3>Anti-Aging Skin Rejuvenation</h3>
                  <ul className="veenadoc-search-queries-list">
                      <li>Homeopathy for collagen support, hormonal balance, antioxidant status</li>
                      <li>Clinical Cosmetology treatments such as mild peels, boosters (vitamin serums), micro-needling adjunct (if H-Cura offers it), and post-procedure care through homeopathic supplements or remedies</li>
                  </ul>
                  <h3>Skin Texture &amp; Glow Enhancement</h3>
                  <ul className="veenadoc-search-queries-list">
                      <li>Hydration-boosting treatments (customizable aesthetic facials under clinic supervision)</li>
                      <li>Herb-supportive homeopathic care for improved skin elasticity, reduced fine lines, and improved skin tone</li>
                  </ul>
                  <h3>Scar &amp; Stretch Mark Management</h3>
                  <ul className="veenadoc-search-queries-list">
                      <li>Internal homeopathic support to promote healing and skin regeneration</li>
                      <li>Coordination with topical or procedure-based therapies available via clinic’s cosmetology / dermatology partners</li>
                  </ul>
                  <p>These treatments are offered in a planned package format at H-Cura, where Dr. Uma Barathi prescribes internal homeopathic protocols and oversees aesthetic follow-ups. Her role is central in shaping the homeopathy + cosmetology interface.</p>
                </div>

                <div className="veenadoc-article-block"> {/* Keeping veenadoc classname */}
                  <h2>Advanced Hair &amp; Scalp Treatments</h2> {/* Updated Heading */}
                  <p>Dr. Uma Barathi is also deeply involved in advanced hair-care and trichology offerings at H-Cura, combining her Diploma in Trichology with homeopathic wellness plans. Some of the key hair / scalp treatments she supports or refers to within the clinic include:</p>
                  <h3>Comprehensive Hair-Fall Workup</h3>
                  <ul className="veenadoc-search-queries-list">
                      <li>Including hormonal evaluation, nutritional deficiency screening, scalp microbiome discussion (in conjunction with lab diagnostics available via H-Cura)</li>
                  </ul>
                  <h3>Homeopathic Adjuncts for Hair Growth</h3>
                  <ul className="veenadoc-search-queries-list">
                      <li>Prescribing homeopathic remedies tailored to reduce hair shedding, support follicular health, and improve overall hair density</li>
                  </ul>
                  <h3>Low-Level Laser Therapy (LLLT) Support Guidance</h3>
                  <ul className="veenadoc-search-queries-list">
                      <li>While the laser device may be managed by H-Cura’s dermatology / cosmetology partner, Dr. Uma Barathi integrates her homeopathic regimen with post-laser care, guiding patients on timing, supportive nutrition, and remedies</li>
                  </ul>
                  <h3>Platelet-Rich Plasma (PRP) Adjunct Care (where available at H-Cura)</h3>
                  <ul className="veenadoc-search-queries-list">
                      <li>She collaborates with the clinic’s procedure-based service for PRP scalp injections and supports post-PRP care via homeopathic protocols to enhance recovery and improve results</li>
                  </ul>
                  <h3>Scalp Boosters &amp; Serums</h3>
                  <ul className="veenadoc-search-queries-list">
                      <li>Overseeing follow-up and maintenance protocols including homeopathic supportive serums, dietary suggestions, and checks on micronutrient status</li>
                  </ul>
                  <h3>Postpartum Hair Loss &amp; Female Pattern Hair Loss</h3>
                  <ul className="veenadoc-search-queries-list">
                      <li>Specializing in care plans for new mothers or patients with hormonal fluctuations — combining her homeopathic remedies with aesthetic-grade formulas under consultation at H-Cura</li>
                  </ul>
                  <h3>Hair Thickness &amp; Quality Enhancement Programs</h3>
                  <ul className="veenadoc-search-queries-list">
                      <li>Packages that blend periodic in-clinic treatments with homeopathic follow-ups to sustain thick, healthy hair over the long term</li>
                  </ul>
                </div>

                <div className="veenadoc-article-block"> {/* Keeping veenadoc classname */}
                  <h2>Why Patients Choose Her at H-Cura</h2> {/* Updated Heading */}
                  <p>Patients looking for homeopathy &amp; aesthetic doctor in Chennai or skin and hair specialist under homeopathy often select Dr. Uma Barathi at H-Cura for multiple reasons:</p>
                  <ul>
                      <li className="veenadoc-search-queries-list">She is one of the few practitioners with both homeopathy and aesthetic / trichology training in the local region.</li>
                      <li className="veenadoc-search-queries-list">Because she works within H-Cura Multispeciality Clinic, patients can access lab diagnostics, dermatology / cosmetology referrals, procedural support (laser / PRP), and house-keeping follow-up — all coordinated seamlessly.</li>
                      <li className="veenadoc-search-queries-list">Her approach is deeply holistic: she treats not just the superficial signs, but the underlying body imbalances that contribute to skin or hair issues.</li>
                      <li className="veenadoc-search-queries-list">She is approachable and communicates clearly — patients appreciate her explaining how homeopathic remedies support their aesthetic goals, what lifestyle modifications they may need, and how the treatments mesh with their daily lives.</li>
                      <li className="veenadoc-search-queries-list">Her specialization as a female homeopathy &amp; aesthetics doctor also appeals to patients seeking a caring and nuanced perspective on beauty + wellness.</li>
                  </ul>
                </div>

                <div className="veenadoc-article-block"> {/* Keeping veenadoc classname */}
                  <h2>Contact &amp; Appointments</h2> {/* Updated Heading */}
                  <p>Dr. Uma Barathi S A is available for consultations at H-Cura Multispeciality Clinic, Chennai. Whether you’re seeking help with persistent acne, pigmentation, hair thinning, or simply want a skin-glow / hair-health maintenance plan, bookings can be made through the clinic’s website or appointment desk.</p>
                  <p>She is committed to continuing education, staying updated with evidence-based protocols in cosmetology, trichology, and homeopathy. Her goal is to ensure that H-Cura remains a centre of excellence for holistic aesthetic &amp; wellness care in Chennai.</p>
                </div>

                {/* Conclusion */}
                <div className="veenadoc-article-block veenadoc-conclusion-block"> {/* Keeping veenadoc classname */}
                  <h2>Choose Dr. Uma Barathi S A for Complete Wellness</h2> {/* Updated Heading */}
                  <p>
                    Choosing Dr. Uma Barathi S A means selecting a doctor who is committed to your complete health and well-being. She provides the assurance of safe treatments, the expertise of modern aesthetic science, and the compassion of a holistic healer.
                  </p>
                  <p>
                    For anyone searching for the best homeopathy and aesthetic doctor in Chennai, or specifically looking for the top homeopathy doctor in Chennai for skin and hair treatments, Dr. Uma Barathi is the doctor who brings together trust, expertise, and results.
                  </p>
                  <p className="veenadoc-mission-statement"> {/* Keeping veenadoc classname */}
                    <strong>Her mission:</strong> To empower patients with healthier lives, glowing skin, stronger hair, and renewed confidence.
                  </p>
                </div>

              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar"> {/* Keeping veenadoc classname */}

                {/* Philosophy of Care */}
                <div className="veenadoc-article-block veenadoc-philosophy-block"> {/* Keeping veenadoc classname */}
                  <div className="veenadoc-philosophy-quote"> {/* Keeping veenadoc classname */}
                    <div className="veenadoc-quote-icon">💫</div> {/* Keeping veenadoc classname */}
                    <blockquote>
                      "Enhancing beauty and wellness through gentle, holistic care." {/* Updated Quote */}
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Uma Barathi S A's Philosophy of Care</p> {/* Keeping veenadoc classname, Updated Attribution */}
                  </div>
                  <p>
                    She believes that true healing goes beyond temporary relief of symptoms and requires addressing the root cause of illness. This patient-centric approach has positioned her among the best holistic homeopathy doctors in Chennai, where she provides customised treatments for individuals of all age groups.
                  </p>
                </div>

                {/* Locations */}
                <div className="veenadoc-sidebar-card"> {/* Keeping veenadoc classname */}
                  <h3>Practice Locations</h3>
                  <div className="veenadoc-location-item"> {/* Keeping veenadoc classname */}
                    <div className="veenadoc-location-icon">📍</div> {/* Keeping veenadoc classname */}
                    <div className="veenadoc-location-details"> {/* Keeping veenadoc classname */}
                      <h4>Chennai</h4> {/* Updated Location */}
                      <p>Primary practice location</p>
                    </div>
                  </div>
                </div>

                {/* Contact CTA */}
                <div className="veenadoc-sidebar-card veenadoc-cta-card"> {/* Keeping veenadoc classname */}
                  <h3>Book Your Consultation</h3>
                  <p>Experience holistic healthcare with Dr. Uma Barathi's personalized approach.</p> {/* Updated Text */}
                 <button
                  className="veenadoc-sidebar-btn-primary"
                  onClick={() => window.location.href = 'tel:+919964688333'}
                >
                  <span>📞</span>
                  <span>Schedule Appointment</span>
                </button>
                <button
                  className="veenadoc-sidebar-btn-secondary" 
                  onClick={() => window.location.href = 'tel:+919964688333'}
                >
                  <span>💬</span>
                  <span>Get Free Assessment</span>
                </button>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>

      <AutoScrollImageRow/>

       <div className="bangloregfcblog-download-section">
            <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
              Download This Doctor profile as PDF
            </button>
          </div>
    </>
  )
}

export default UmaBarathiDoc
